import { createAsyncThunk } from "@reduxjs/toolkit";

import magnifiAPI from "../../services/api/magnifi";

export const getSettings = createAsyncThunk("accountSettings/getSettings", async (payload) => {
  try {
    const response = await magnifiAPI.getSettings(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const createFolders = createAsyncThunk("accountSettings/createFolders", async (payload) => {
  try {
    const response = await magnifiAPI.createFolders(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
